var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "main-content", staticStyle: { "margin-top": "5px" } },
      [
        _c(
          "el-form",
          { attrs: { disabled: !_vm.isEdit, inline: "", "label-width": "0" } },
          [
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.DateOfDeparture") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("ETD")))]
                    )
                  ]
                ),
                _c("el-date-picker", {
                  class: _vm.isDifferent("etd"),
                  staticStyle: { width: "200px" },
                  attrs: { type: "date", format: "yyyy-MM-dd" },
                  model: {
                    value: _vm.cargoDoc.etd,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "etd", $$v)
                    },
                    expression: "cargoDoc.etd"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.AMSNumber") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("AMS NO")))]
                    )
                  ]
                ),
                _c("el-input", {
                  class: _vm.isDifferent("hblNbr2"),
                  staticStyle: { width: "200px" },
                  model: {
                    value: _vm.cargoDoc.hblNbr2,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "hblNbr2", $$v)
                    },
                    expression: "cargoDoc.hblNbr2"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#0000FF" },
                        attrs: { title: "MBL号码" }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("MB/L NO")))]
                    )
                  ]
                ),
                _c("el-input", {
                  class: _vm.isDifferent("mbl"),
                  staticStyle: { width: "200px" },
                  model: {
                    value: _vm.cargoDoc.mbl,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "mbl", $$v)
                    },
                    expression: "cargoDoc.mbl"
                  }
                })
              ],
              1
            ),
            _c("br"),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.ArrivalDate") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("ETA")))]
                    )
                  ]
                ),
                _c("el-date-picker", {
                  class: _vm.isDifferent("eta"),
                  staticStyle: { width: "200px" },
                  attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                  model: {
                    value: _vm.cargoDoc.eta,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "eta", $$v)
                    },
                    expression: "cargoDoc.eta"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.ShippingType") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("Shipment Type")))]
                    )
                  ]
                ),
                _c(
                  "el-select",
                  {
                    class: _vm.isDifferent("shipmentTypeCode"),
                    staticStyle: { width: "200px" },
                    attrs: { disabled: !_vm.isEdit },
                    model: {
                      value: _vm.cargoDoc.shipmentTypeCode,
                      callback: function($$v) {
                        _vm.$set(_vm.cargoDoc, "shipmentTypeCode", $$v)
                      },
                      expression: "cargoDoc.shipmentTypeCode"
                    }
                  },
                  _vm._l(_vm.ShipmentTypeCode, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      attrs: { label: item.name, value: item.code }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        attrs: { title: _vm.$t("SeaExport.BillOfLadingType") }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("B/L Type")))]
                    )
                  ]
                ),
                _c(
                  "el-select",
                  {
                    class: _vm.isDifferent("amsBlType"),
                    staticStyle: { width: "200px" },
                    attrs: { no: "13", disabled: !_vm.isEdit },
                    model: {
                      value: _vm.cargoDoc.amsBlType,
                      callback: function($$v) {
                        _vm.$set(_vm.cargoDoc, "amsBlType", $$v)
                      },
                      expression: "cargoDoc.amsBlType"
                    }
                  },
                  _vm._l(_vm.AmsBLType, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      attrs: { label: item.name, value: item.code }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c("br"),
            _c(
              "el-form-item",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "105px",
                      "padding-left": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { title: _vm.$t("SeaExport.HtsCode") } },
                      [_vm._v(_vm._s(_vm.getItemTitle("Hts Code")))]
                    )
                  ]
                ),
                _c("el-input", {
                  class: _vm.isDifferent("hsCode"),
                  staticStyle: { width: "200px" },
                  model: {
                    value: _vm.cargoDoc.hsCode,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "hsCode", $$v)
                    },
                    expression: "cargoDoc.hsCode"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "section", staticStyle: { height: "540px" } }, [
      _c(
        "span",
        {
          staticClass: "title",
          attrs: { title: _vm.$t("SeaExport.CustomerShippingInformation") }
        },
        [_vm._v(_vm._s(_vm.getItemTitle("Customer Delivery Info")))]
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabSellingParty",
                    label: _vm.getItemTitle("Seller"),
                    title: _vm.$t("RailwayExport.BoxOwner2")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabSellingParty",
                    attrs: {
                      "party-type": "SE",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabBuyingParty",
                    label: _vm.getItemTitle("Buyer"),
                    title: _vm.$t("SeaExport.Buyer")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabBuyingParty",
                    attrs: {
                      "party-type": "BY",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabManufacturer",
                    label: _vm.getItemTitle("Manufacturer"),
                    title: _vm.$t("Message.Manufacturer")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabManufacturer",
                    attrs: {
                      "party-type": "MF",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "is-show": true,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabConsolidator",
                    label: _vm.getItemTitle("Container Stuffing Location"),
                    title: _vm.$t("SeaExport.Consolidator")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabConsolidator",
                    attrs: {
                      "party-type": "CS",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabBookingParty",
                    label: _vm.getItemTitle("Consolidator"),
                    title: _vm.$t("SeaExport.OriginalBookingParty")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabBookingParty",
                    attrs: {
                      "party-type": "BKP",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabConsignee",
                    label: _vm.getItemTitle("Consignee"),
                    title: _vm.$t("SeaExport.Consignee")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabConsignee",
                    attrs: {
                      "party-type": "CN",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabShipToParty",
                    label: _vm.getItemTitle("Container Ship to"),
                    title: _vm.$t("SeaExport.CargoReceiver")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabShipToParty",
                    attrs: {
                      "party-type": "ST",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabScheduledContainerStuffing",
                    label: _vm.getItemTitle("Packing Point"),
                    title: _vm.$t("SeaExport.PackingPoint")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabScheduledContainerStuffing",
                    attrs: {
                      "party-type": "LG",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    name: "tabImporterofRecord",
                    label: _vm.getItemTitle("Importer"),
                    title: _vm.$t("SeaExport.Importer")
                  }
                },
                [
                  _c("tab-customer", {
                    ref: "tabImporterofRecord",
                    attrs: {
                      "party-type": "IM",
                      "isf-type": _vm.isfType,
                      job: _vm.job,
                      "cargo-doc": _vm.cargoDoc,
                      "is-edit": _vm.isEdit,
                      "party-name-list": _vm.partyNameList
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }